import ManualCrud from './ManualCrud'
export {ManualCrud}
export default ManualCrud
